import React, { useMemo, useReducer } from 'react'
import useDispatch from '~editor/hooks/useDispatch'
import {
  AnyActionType,
  ActionTypes,
  KeybindAction,
  getActionTypeLabel,
  IActionComponentProps,
} from '~core/forge.type'
import { Text, SimpleGrid } from '@chakra-ui/react'
import { Select } from '~editor/components/Select'
import { RecordKeybindComponent } from '~editor/ActionEditor/ActionsComponents/keybind/RecordKeybindComponent'
import { DropdownKeybindComponent } from '~editor/ActionEditor/ActionsComponents/keybind/DropdownKeybindComponent'
import { Box } from '~core/components'
import { RecordingAction } from '~editor/models/editor'

const recordingReducer = (state: boolean, action: RecordingAction) => {
  switch (action) {
    case RecordingAction.START_RECORDING:
      return true
    case RecordingAction.STOP_RECORDING:
      return false
    case RecordingAction.TOGGLE_RECORDING:
      return !state
  }
}

export interface KeyPairs {
  key: string
  code: string
}

const ActionTypesOptions = KeybindAction.getAllowedTypes().map(
  (actionType) => ({
    label: getActionTypeLabel(actionType),
    value: actionType,
  }),
)

export interface IProps extends IActionComponentProps {
  action: KeybindAction
}

export const KeybindActionComponent = ({
  action,
  actions,
  activeActionGesture,
  isDisabled,
}: IProps) => {
  const dispatch = useDispatch()
  const [recording, recordingDispatch] = useReducer(recordingReducer, false)
  const selectedOption = useMemo(
    () => ActionTypesOptions.find((option) => option.value === action.type),
    [action.type],
  )

  Array().entries()

  const showDropdowns = !recording || (recording && action.keys.length > 0)

  return (
    <SimpleGrid
      flex="1"
      templateColumns={!action?.typeLocked ? '1fr auto auto' : '1fr'}
      alignItems="center"
      gap="12px"
    >
      <Box display="flex" flex="1" alignItems="center">
        {showDropdowns && (
          <DropdownKeybindComponent
            {...{
              action,
              actions,
              activeActionGesture,
              isDisabled,
              recording,
            }}
          />
        )}

        <RecordKeybindComponent
          {...{
            action,
            actions,
            activeActionGesture,
            isDisabled,
            recording,
            recordingDispatch,
          }}
        />
      </Box>

      {!action?.typeLocked && (
        <>
          <Text color="ui.text.grey" fontWeight="700">
            {'|'}
          </Text>
          <Select
            width="130px"
            height="32px"
            options={ActionTypesOptions}
            defaultValue={ActionTypesOptions[0]}
            isSearchable={false}
            isDisabled={isDisabled}
            value={selectedOption}
            onChange={(option) => {
              if (!option) return

              const value: ActionTypes = (option as any).value
              dispatch.nodes.updateActions({
                actionGestureType: activeActionGesture,
                actions: actions.map((_a: AnyActionType) => {
                  const _action = { ..._a }

                  if (action.id === _action.id) {
                    if (Object.keys(ActionTypes).includes(value)) {
                      _action.type = value
                    }
                  }

                  return _action
                }),
              })
            }}
          />
        </>
      )}
    </SimpleGrid>
  )
}

export default KeybindActionComponent
